/**
 * REACT
 */

import React from 'react';
import ReactDOM from 'react-dom';

/**
 * REDUX
 */

import { Provider } from 'react-redux';
import { store } from './store';

/**
 * Router
 */
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';


/**
 * import history
 */
import history from './history';

/**
 * SERVICE WORKERS
 */
import registerServiceWorker from './registerServiceWorker';

/**
 * EEZEE CONTAINERS
 */

import LoginPage from './containers/login-page';
import AdminApp from './app';
// import BillingHistory from './containers/billing-history';
// import Favourites from './containers/favourites';
// import DashBoard from './containers/dash-board';
// import Profile from './containers/profile';
// import Orders from './containers/orders';

/**
 * ANALYTICS
 */

/**
 * COOKIES
 */

// import Cookies from 'js-cookie';

/**
 * WEB SOCKETS
 */

// import io from 'socket.io-client';

/**
 * ANT DESIGN
 */
import { LocaleProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';

import './index.css';
import 'antd/dist/antd.css';

let EEZEE_URL, SUPPLIER_URL, ERP_URL, API_ENDPOINT, ADMIN_URL, AI_EEZEE_ENDPOINT, QUICKBOOKS_AUTH_URL, RFID_SERVER_ENDPOINT, MKT_BASE_CURRENCY;

MKT_BASE_CURRENCY = process.env.REACT_APP_MKT_BASE_CURRENCY;

console.log("JASPER & KEN'S SANITY CHECK", MKT_BASE_CURRENCY);

let QUICKBOOKS_CLIENT_ID = {
  'SGD': {
    'production': 'Q0YIfRJrQKnXbWDUSx2O4GkaZHDs7vWLgyjlY6GpG9LsLD0qRF',
    'staging': 'Q0ObokhU19I0lqGfPOD9CfJWYPPX7m1VbIz6OSTHrbL65dzIMz',
    'dev': 'Q0ObokhU19I0lqGfPOD9CfJWYPPX7m1VbIz6OSTHrbL65dzIMz'
  },
  'IDR': {
    'production': 'BBzurhVFiEn2GbBubxdvuIjEVZUgFNkftUCrrX8GrsQSQwMuvd',
    'staging': 'BBck7Ym4wTsYjAkp6sI4P0ABhIzJuwe5GC7YyDbPmkYOhzkMET',
    'dev': 'BBck7Ym4wTsYjAkp6sI4P0ABhIzJuwe5GC7YyDbPmkYOhzkMET'
  },
  'MYR': {
    'production': 'ABO4r7pTslH78a7jJ50U477EWxp86zuLhZQYsYziNaWwwpwbxy',
    'staging': 'ABc9FAiRXFQjl63atvbFccclD18EfcTWgcgUxE9pXLfdKRxCy4',
    'dev': 'ABc9FAiRXFQjl63atvbFccclD18EfcTWgcgUxE9pXLfdKRxCy4'
  },
  /* COPIED FROM MYR, DONT USE */
  'PHP': {
    'production': 'ABO4r7pTslH78a7jJ50U477EWxp86zuLhZQYsYziNaWwwpwbxy',
    'staging': 'ABc9FAiRXFQjl63atvbFccclD18EfcTWgcgUxE9pXLfdKRxCy4',
    'dev': 'ABc9FAiRXFQjl63atvbFccclD18EfcTWgcgUxE9pXLfdKRxCy4'
  },
  /* COPIED FROM MYR, DONT USE */
  'THB': {
    'production': 'ABO4r7pTslH78a7jJ50U477EWxp86zuLhZQYsYziNaWwwpwbxy',
    'staging': 'ABc9FAiRXFQjl63atvbFccclD18EfcTWgcgUxE9pXLfdKRxCy4',
    'dev': 'ABc9FAiRXFQjl63atvbFccclD18EfcTWgcgUxE9pXLfdKRxCy4'
  }
};

let QUICKBOOKS_REALM_ID = {
  'SGD': {
    'production': '123146039700384',
    'staging': '193514846636444',
    'dev': '193514846636444'
  },
  'IDR': {
    'production': '13633946246007644',
    'staging': '4620816365164554980',
    'dev': '4620816365164554980'
  },
  'MYR': {
    'production': '9130351752761496',
    'staging': '4620816365164583330',
    'dev': '4620816365164583330'
  },
  /* COPIED FROM MYR, DONT USE */
  'PHP': {
    'production': '9130351752761496',
    'staging': '4620816365164583330',
    'dev': '4620816365164583330'
  },
  /* COPIED FROM MYR, DONT USE */
  'THB': {
    'production': '9130351752761496',
    'staging': '4620816365164583330',
    'dev': '4620816365164583330'
  }
};

let ADMIN_ENDPOINTS = {
  'SGD': {
    'production': 'https://admin.eezee.sg',
    'staging': 'https://admin.eezee.dev',
    'dev': 'http://admin.teezee.sg:3000',
    'api': 'https://api.eezee.sg'
  },
  'IDR': {
    'production': 'https://admin.eezee.co.id',
    'staging': 'https://admin.eezee.dev',
    'dev': 'http://admin.teezee.sg:3000',
    'api': 'https://api.eezee.co.id'
  },
  'MYR': {
    'production': 'https://admin.eezee.com.my',
    'staging': 'https://admin.eezee.dev',
    'dev': 'http://admin.teezee.sg:3000',
    'api': 'https://api.eezee.com.my'
  },
  'PHP': {
    'production': 'https://admin.eezee.ph',
    'staging': 'https://admin.eezee.dev',
    'dev': 'http://admin.teezee.sg:3000',
    'api': 'https://api.eezee.ph'
  },
  'THB': {
    'production': 'https://admin.eezee.co.th',
    'staging': 'https://admin.eezee.dev',
    'dev': 'http://admin.teezee.sg:3000',
    'api': 'https://api.eezee.co.th'
  },
};

let SELLER_ENDPOINTS = {
  'SGD': {
    'production': 'https://seller.eezee.sg',
    'staging': 'https://seller.eezee.dev',
    'dev': 'http://seller.teezee.sg:3002',
  },
  'IDR': {
    'production': 'https://seller.eezee.co.id',
    'staging': 'https://seller.eezee.dev',
    'dev': 'http://seller.teezee.sg:3002',
  },
  'MYR': {
    'production': 'https://seller.eezee.com.my',
    'staging': 'https://seller.eezee.dev',
    'dev': 'http://seller.teezee.sg:3002',
  },
  'PHP': {
    // @todo - Seller Frontend not setup for PH
    'production': 'https://seller.eezee.sg',
    'staging': 'https://seller.eezee.dev',
    'dev': 'http://seller.teezee.sg:3002',
  },
  'THB': {
    // @todo - Seller Frontend not setup for TH
    'production': 'https://seller.eezee.co.th',
    'staging': 'https://seller.eezee.dev',
    'dev': 'http://seller.teezee.sg:3002',
  },
};

let ERP_ENDPOINTS = {
  'SGD': {
    'production': 'https://erp.eezee.sg',
    'staging': 'https://erp.eezee.dev',
    'dev': 'http://erp.teezee.sg:8081',
  },
  'IDR': {
    'production': 'https://erp.eezee.co.id',
    'staging': 'https://erp.eezee.dev',
    'dev': 'http://erp.teezee.sg:8081',
  },
  'MYR': {
    'production': 'https://erp.eezee.com.my',
    'staging': 'https://erp.eezee.dev',
    'dev': 'http://erp.teezee.sg:8081',
  },
  'PHP': {
    'production': 'https://erp.eezee.ph',
    'staging': 'https://erp.eezee.dev',
    'dev': 'http://erp.teezee.sg:8081',
  },
  'THB': {
    'production': 'https://erp.eezee.co.th',
    'staging': 'https://erp.eezee.dev',
    'dev': 'http://erp.teezee.sg:8081',
  },
};

switch (process.env.REACT_APP_CUSTOM_NODE_ENV) {
  case "production":
    EEZEE_URL = `https://eezee.sg`;
    SUPPLIER_URL = SELLER_ENDPOINTS[MKT_BASE_CURRENCY]['production'];
    ERP_URL = ERP_ENDPOINTS[MKT_BASE_CURRENCY]['production'];
    API_ENDPOINT = ADMIN_ENDPOINTS[MKT_BASE_CURRENCY]['api'];
    ADMIN_URL = ADMIN_ENDPOINTS[MKT_BASE_CURRENCY]['production'];
    AI_EEZEE_ENDPOINT = "https://ai.eezee.sg";

    QUICKBOOKS_AUTH_URL = `https://appcenter.intuit.com/connect/oauth2?client_id=${QUICKBOOKS_CLIENT_ID[MKT_BASE_CURRENCY]['production']}&redirect_uri=${ADMIN_URL}%2Forders&scope=com.intuit.quickbooks.accounting&response_type=code&state=1#/Authorize/${QUICKBOOKS_REALM_ID[MKT_BASE_CURRENCY]['production']}`;
    RFID_SERVER_ENDPOINT = "http://192.168.10.212:8082";
    break;
  case "staging":

    EEZEE_URL = `https://eezee.dev`;
    SUPPLIER_URL = SELLER_ENDPOINTS[MKT_BASE_CURRENCY]['staging'];
    ERP_URL = ERP_ENDPOINTS[MKT_BASE_CURRENCY]['staging'];
    API_ENDPOINT = 'https://api.eezee.dev';
    ADMIN_URL = ADMIN_ENDPOINTS[MKT_BASE_CURRENCY]['staging'];
    AI_EEZEE_ENDPOINT = "https://ai.eezee.dev";

    QUICKBOOKS_AUTH_URL = `https://appcenter.intuit.com/connect/oauth2?client_id=${QUICKBOOKS_CLIENT_ID[MKT_BASE_CURRENCY]['staging']}&redirect_uri=${ADMIN_URL}%2Forders&scope=com.intuit.quickbooks.accounting&response_type=code&state=1#/Authorize/${QUICKBOOKS_REALM_ID[MKT_BASE_CURRENCY]['staging']}`;
    RFID_SERVER_ENDPOINT = "http://192.168.10.212:8082";
    break;
  default:
    EEZEE_URL = `http://teezee.sg:3001`;
    SUPPLIER_URL = SELLER_ENDPOINTS[MKT_BASE_CURRENCY]['dev'];
    ERP_URL = ERP_ENDPOINTS[MKT_BASE_CURRENCY]['dev'];
    API_ENDPOINT = 'http://api.teezee.sg:8080';
    ADMIN_URL = ADMIN_ENDPOINTS[MKT_BASE_CURRENCY]['dev'];

    QUICKBOOKS_AUTH_URL = `https://appcenter.intuit.com/connect/oauth2?client_id=${QUICKBOOKS_CLIENT_ID[MKT_BASE_CURRENCY]['dev']}&redirect_uri=${ADMIN_URL}%2Forders&scope=com.intuit.quickbooks.accounting&response_type=code&state=1#/Authorize/${QUICKBOOKS_REALM_ID[MKT_BASE_CURRENCY]['dev']}`;
    RFID_SERVER_ENDPOINT = "http://192.168.10.212:8082";
    break;

}

const URL_ENDPOINT = API_ENDPOINT;

// Defaults MKT_BASE_CURRENCY to "SGD" if not set
if (["SGD", "IDR", "MYR", "PHP", "THB"].indexOf(MKT_BASE_CURRENCY) === -1) {
  MKT_BASE_CURRENCY = "SGD";
}


let COUNTRY_CODE = "SG";
switch (MKT_BASE_CURRENCY) {
  case "IDR": {
    COUNTRY_CODE = 'ID';
    break;
  }
  case "MYR": {
    COUNTRY_CODE = 'MY';
    break;
  }
  case "PHP": {
    COUNTRY_CODE = 'PH';
    break;
  }
  case "THB": {
    COUNTRY_CODE = 'TH';
    break;
  }
  default: {
    COUNTRY_CODE = 'SG';
    break;
  }
}

export {
  ADMIN_URL,
  EEZEE_URL,
  SUPPLIER_URL,
  ERP_URL,
  API_ENDPOINT,
  URL_ENDPOINT,
  AI_EEZEE_ENDPOINT,
  QUICKBOOKS_AUTH_URL,
  RFID_SERVER_ENDPOINT,
  MKT_BASE_CURRENCY,
  COUNTRY_CODE
};

// const socket = io.connect(`${URL_ENDPOINT}/adminezpz`);

const App = (props) => {

  return (

    <Route path="/:root?" render={
      (props) => (
        <Switch>
          {/* everything else */}
          <Route path="/" component={AdminApp} />
        </Switch>
      )
    } />

  );
};

// {/* / -> dashboard */}
//       {/* /favourites */}
//       {/* /credit */}
//       {/* /orders */}
//       {/* /profile */}


ReactDOM.render(
  // <SocketProvider socket={socket}>

  <Provider store={store}>

    <LocaleProvider locale={enUS}>
      <Router history={history}>
        <Route component={App} />
      </Router>
    </LocaleProvider>

  </Provider>,
  // </SocketProvider>,
  document.getElementById('root')
);

document.body.className = "layout-column";
document.getElementById('root').className = "layout-column overflow-hidden";

if (!window.atob) {
  var tableStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var table = tableStr.split("");

  window.btoa = function (bin) {
    for (var i = 0, j = 0, len = bin.length / 3, base64 = []; i < len; ++i) {
      var a = bin.charCodeAt(j++), b = bin.charCodeAt(j++), c = bin.charCodeAt(j++);
      if ((a | b | c) > 255) throw new Error("String contains an invalid character");
      base64[base64.length] = table[a >> 2] + table[((a << 4) & 63) | (b >> 4)] +
        (isNaN(b) ? "=" : table[((b << 2) & 63) | (c >> 6)]) +
        (isNaN(b + c) ? "=" : table[c & 63]);
    }
    return base64.join("");
  };
}

window.hexToBase64 = function (str) {
  return btoa(String.fromCharCode.apply(null,
    str.replace(/\r|\n/g, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" "))
  );
};

// document.addEventListener("keyDown", ( event ) => {
//   if (!( String.fromCharCode(event.which).toLowerCase() === 's' && event.ctrlKey) && !(event.which === 19)) return true;

//   event.preventDefault();
//   console.log("Ctrl-s pressed");
//   return false;

// }, false);



registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js